var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _rect4, _rect5, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBuch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M42.128 25.635V15.118a.627.627 0 0 0-.753-.615c-8.584 1.942-9.76 8.162-9.889 9.125l-.018.126-.02-.126c-.125-.963-1.304-7.183-9.887-9.125a.627.627 0 0 0-.752.615v10.517h21.319Z",
  fill: "#EDF4F3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m14.775 19.69 1.808-2.257a1.254 1.254 0 0 1 1.192-.455c7.794 1.394 13.693 5.56 13.693 6.776 0-1.217 5.898-5.382 13.691-6.776.45-.077.907.098 1.192.455l1.808 2.257v10.961H14.775v-10.96Z",
  fill: "#EDF4F3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m48.774 19.418-14.422 6.346a.627.627 0 0 0-.376.574v-.076a.627.627 0 0 0-.627-.627h-3.763a.627.627 0 0 0-.627.627v.076a.627.627 0 0 0-.376-.574l-14.422-6.346a.627.627 0 0 0-.878.573v23.713c0 .249.148.474.376.574l14.422 6.346a.627.627 0 0 0 .878-.574v.04c0 .346.281.627.627.627h3.763c.346 0 .627-.28.627-.627v-.04a.627.627 0 0 0 .878.574l14.422-6.346a.627.627 0 0 0 .376-.574V19.991a.627.627 0 0 0-.878-.573Z",
  fill: "#405B73"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 28.959,
  y: 25.635,
  width: 5.016,
  height: 25.082,
  rx: 2.508,
  fill: "#405B73"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 28.959,
  y: 29.398,
  width: 5.016,
  height: 2.508,
  rx: 1.254,
  fill: "#F0C419"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 28.959,
  y: 44.447,
  width: 5.016,
  height: 2.508,
  rx: 1.254,
  fill: "#F0C419"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m46.784 31.448-9.406 4.426a.627.627 0 0 1-.894-.568v-4.884c0-.243.14-.464.36-.567l9.406-4.427a.627.627 0 0 1 .894.568v4.884c0 .243-.14.464-.36.568ZM16.151 31.448l9.406 4.426a.627.627 0 0 0 .894-.568v-4.884a.627.627 0 0 0-.36-.567l-9.406-4.427a.627.627 0 0 0-.894.568v4.884c0 .243.14.464.36.568Z",
  fill: "#F4CC54"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 28.959,
  y: 29.398,
  width: 5.016,
  height: 2.508,
  rx: 1.254,
  fill: "#F4CC54"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 28.959,
  y: 44.447,
  width: 5.016,
  height: 2.508,
  rx: 1.254,
  fill: "#F4CC54"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.451 40.057a.623.623 0 0 1-.267-.06l-10.66-5.016a.627.627 0 1 1 .534-1.135l10.66 5.016a.627.627 0 0 1-.267 1.195ZM25.183 42.595a.623.623 0 0 1-.268-.06l-8.12-3.822a.627.627 0 1 1 .533-1.135l8.124 3.825a.627.627 0 0 1-.268 1.192h-.001ZM36.484 40.057a.627.627 0 0 1-.267-1.195l10.66-5.016a.627.627 0 0 1 .534 1.135l-10.66 5.016a.626.626 0 0 1-.267.06ZM37.752 42.595a.627.627 0 0 1-.267-1.191l8.124-3.825a.627.627 0 1 1 .533 1.134l-8.122 3.825a.627.627 0 0 1-.268.057Z",
  fill: "#F4CC54"
})));
export default SvgIconBuch;